<template>
    <div class="container-dashboard">
        <div class="my-layout">
            <md-card class="custom-card">
                <md-card-header class="md-card-header-icon md-card-header-warning card-container">
                    <div class="create-container pull-right">
                        <md-button
                            :disabled="loadingRequiredData"
                            title="Create adjustment"
                            class="md-primary md-just-icon md-round pull-right custom-add"
                            @click.stop="createAdjustment"
                        >
                            <md-icon>library_add</md-icon>
                        </md-button>
                    </div>
                </md-card-header>
                <md-card-content class="body-list">
                    <div
                        :class="[{ fixed: isFixedSelector }]"
                        class="bulk-section sticky-selection"
                        v-if="selectedRows.length > 1"
                    >
                        <div>
                            {{ selectedRows.length }} adjustment{{ selectedRows.length > 1 ? 's' : '' }} selected.
                        </div>
                        <div>
                            <md-button class="md-round md-just-icon md-success" title="Approve" @click="bulkApprove">
                                <md-icon>thumb_up</md-icon>
                            </md-button>

                            <md-button class="md-round md-just-icon md-danger" title="Deny" @click="bulkDeny">
                                <md-icon>thumb_down</md-icon>
                            </md-button>

                            <md-button class="md-round md-just-icon md-danger" title="Delete" @click="bulkDelete">
                                <md-icon>delete</md-icon>
                            </md-button>
                        </div>
                    </div>
                    <div>
                        <md-table class="context-menu-support custom-paginated-table">
                            <md-table-row slot="header">
                                <md-checkbox
                                    class="checkbox-container checkbox-head"
                                    v-model="isSelectAll"
                                    @change="onSelectAll(isSelectAll)"
                                ></md-checkbox>
                                <md-table-head>Created Date</md-table-head>
                                <md-table-head>{{ getColumnName() }}</md-table-head>
                                <md-table-head>Adjustment Date</md-table-head>
                                <md-table-head>Amount</md-table-head>
                                <md-table-head>Category</md-table-head>
                                <md-table-head>Description</md-table-head>
                                <md-table-head>Requested By</md-table-head>
                                <md-table-head>Approved By</md-table-head>
                                <md-table-head>Approval Status</md-table-head>
                                <md-table-head v-if="isTeamOwner">Actions</md-table-head>
                            </md-table-row>
                            <template v-if="!isLoading && adjustmentList && adjustmentList.length > 0">
                                <md-table-row v-for="(adj, index) in adjustmentList" :key="index">
                                    <md-table-cell>
                                        <md-checkbox
                                            class="checkbox-container"
                                            v-if="
                                                !adj.customerInvoiceId && !adj.teamMemberInvoiceId && hideIfDeleted(adj)
                                            "
                                            v-model="adj.isSelect"
                                            @change="selectRow(adj)"
                                        ></md-checkbox>
                                        <md-checkbox v-else disabled />
                                    </md-table-cell>
                                    <md-table-cell class="name-container">
                                        {{ adj.createdDate | dateFormat(DATE_TYPES.standardDate) }}
                                    </md-table-cell>

                                    <md-table-cell class="name-container" v-if="adj.teamMemberName">
                                        {{ adj.teamMemberName }}
                                    </md-table-cell>
                                    <md-table-cell class="name-container" v-else>{{ adj.customerName }}</md-table-cell>

                                    <md-table-cell class="name-container">
                                        {{ adj.tripDate | dateFormat(DATE_TYPES.standardDate) }}
                                    </md-table-cell>

                                    <md-table-cell class="name-container" v-if="adj.percentageAmount">
                                        {{ adj.percentageAmount }}%
                                    </md-table-cell>
                                    <md-table-cell class="name-container" v-else-if="adj.amount < 0">
                                        ({{ adj.amount | currency(user.teamCurrency) }})
                                    </md-table-cell>
                                    <md-table-cell class="name-container" v-else>
                                        {{ adj.amount | currency(user.teamCurrency) }}
                                    </md-table-cell>

                                    <md-table-cell>
                                        {{ getCategory(adj.invoiceAdjustmentCategory.invoiceAdjustmentCategoryId) }}
                                    </md-table-cell>
                                    <md-table-cell>{{ adj.description }}</md-table-cell>
                                    <md-table-cell class="name-container">{{ adj.createByUserName }}</md-table-cell>
                                    <md-table-cell class="name-container">{{ adj.approvedByUserName }}</md-table-cell>
                                    <md-table-cell class="name-container">
                                        <div
                                            :class="
                                                `status status-${getStatus(adj.invoiceAdjustmentStatusId)
                                                    .toLowerCase()
                                                    .replace(/\s+/g, '')}`
                                            "
                                        >
                                            {{ getStatus(adj.invoiceAdjustmentStatusId) }}
                                        </div>
                                    </md-table-cell>

                                    <md-table-cell v-if="isTeamOwner" class="actions-container">
                                        <div v-if="hideIfDeleted(adj)">
                                            <md-button
                                                @click.stop="approveAdjustment(adj)"
                                                title="Approve"
                                                class="md-success md-just-icon md-round action-icon"
                                                v-if="show(adj) && showApproveIcon(adj)"
                                            >
                                                <div v-if="!adj.approving">
                                                    <md-icon>thumb_up</md-icon>
                                                </div>
                                                <div v-else class="sync-loader">
                                                    <straight-line-loader />
                                                </div>
                                            </md-button>
                                            <md-button
                                                @click.stop="denyAdjustment(adj)"
                                                title="Deny"
                                                class="md-danger md-just-icon md-round action-icon"
                                                v-if="show(adj) && showUnapproveIcon(adj)"
                                            >
                                                <div v-if="!adj.denying">
                                                    <md-icon>thumb_down</md-icon>
                                                </div>
                                                <div v-else class="sync-loader">
                                                    <straight-line-loader />
                                                </div>
                                            </md-button>
                                            <md-button
                                                @click.stop="edit(adj)"
                                                title="Edit"
                                                class="md-warning md-just-icon md-round action-icon"
                                                v-if="show(adj) && showEditIcon(adj)"
                                            >
                                                <md-icon>edit</md-icon>
                                            </md-button>
                                            <md-button
                                                @click.stop="deleteAdjustment(adj)"
                                                title="Delete"
                                                class="md-danger md-just-icon md-round action-icon"
                                                v-if="show(adj) && showDeleteIcon(adj)"
                                            >
                                                <div v-if="!adj.deleting">
                                                    <md-icon>delete</md-icon>
                                                </div>
                                                <div v-else class="sync-loader">
                                                    <straight-line-loader />
                                                </div>
                                            </md-button>
                                        </div>
                                    </md-table-cell>
                                </md-table-row>
                            </template>
                            <template v-else>
                                <div v-if="isLoading" class="content-loader loading-position">
                                    <fade-loader :loading="isLoading" color="#333333" />
                                    <span>LOADING</span>
                                </div>
                                <p v-else class="no-result-message">
                                    No results matching your search/filter could be found.
                                </p>
                            </template>
                        </md-table>
                    </div>
                </md-card-content>
            </md-card>
            <md-card-actions class="page-footer" md-alignment="space-between">
                <div>
                    <p v-if="total === pagination.perPage" class="card-category">
                        Page {{ pagination.currentPage }} of many
                    </p>
                    <p v-else class="card-category">Page {{ pagination.currentPage }} of {{ totalPages }}</p>
                </div>
                <pagination
                    v-model="pagination.currentPage"
                    class="pagination-no-border pagination-success"
                    :per-page="pagination.perPage"
                    :total="total"
                    @change-page="handleChangePage($event, pagination.perPage)"
                />
            </md-card-actions>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import FadeLoader from 'vue-spinner/src/FadeLoader';
import { PAGINATION_DEFAULTS } from '@/utils/defaults';
import { GeneralMixin } from '@/mixins/GeneralMixin';
import { Pagination, StraightLineLoader } from '@/components';
import { handleRequests, showErrorMessage } from '@/helpers';
import { INVOICE_ADJUSTMENT_STATUSES } from '@/utils/constants';
import CreateOrUpdateInvoiceAdjustmentModal from './Modals/CreateOrUpdateInvoiceAdjustmentModal';

export default {
    name: 'InvoiceAdjustmentPaymentOverview',
    mixins: [GeneralMixin],
    props: {
        filter: {
            type: Object,
            default: null
        }
    },
    components: {
        Pagination,
        FadeLoader,
        StraightLineLoader
    },
    computed: {
        ...mapGetters({
            allTeamMembers: 'team/teamMembers',
            invoiceAdjustmentStatuses: 'team/invoiceAdjustmentStatuses',
            invoiceAdjustmentCategories: 'team/invoiceAdjustmentCategories',
            customers: 'team/customers',
            user: 'user/user',
            isTeamOwner: 'user/isTeamOwner'
        }),
        getStatus() {
            return (invoiceAdjustmentStatusId) =>
                this.adjustmentStatuses.find((status) => status.invoiceAdjustmentStatusId === invoiceAdjustmentStatusId)
                    ?.status;
        },
        currentPageMax() {
            const highBound = this.currentPageMin + this.pagination.perPage;
            return this.total < highBound ? this.total : highBound;
        },
        currentPageMin() {
            return this.pagination.perPage * (this.pagination.currentPage - 1);
        },
        total() {
            return this.pagination.total ?? 0;
        },
        totalPages() {
            if (this.total > 0) {
                return Math.ceil(this.total / this.pagination.perPage);
            }
            return 1;
        },
        show() {
            return (adjustment) =>
                (adjustment.customerIds &&
                    !adjustment.customerInvoiceId &&
                    adjustment.teamMemberIds &&
                    !adjustment.teamMemberInvoiceId) ||
                adjustment.invoiceAdjustmentStatusId !==
                    this.adjustmentStatuses.find((status) => status.status === INVOICE_ADJUSTMENT_STATUSES.Invoiced)
                        ?.invoiceAdjustmentStatusId;
        },
        hideIfDeleted() {
            return (adjustment) => {
                return (
                    adjustment.invoiceAdjustmentStatusId !==
                    this.adjustmentStatuses.find((status) => status.status === INVOICE_ADJUSTMENT_STATUSES.Deleted)
                        ?.invoiceAdjustmentStatusId
                );
            };
        }
    },
    watch: {
        filter(newVal, oldVal) {
            this.filters = Object.assign(this.filters, this.filter);
            this.handleFilterChanged(this.filters);
        },
        '$route.params.type': function(newVal) {
            this.isDriver = this.$route.params.type === 'team-member-adjustments';
            this.isCustomer = this.$route.params.type === 'customer-adjustments';
        }
    },
    data() {
        return {
            isListLoading: false,
            filters: Object,
            isFixedSelector: false,
            selectedRows: [],
            isSelectAll: false,
            adjustmentList: [],
            pagination: PAGINATION_DEFAULTS,
            teamMembers: [],
            customerList: [],
            adjustmentStatuses: [],
            adjustmentCategories: [],
            loadingRequiredData: true,
            isLoading: false,
            isDriver: this.$route.params.type === 'team-member-adjustments',
            isCustomer: this.$route.params.type === 'customer-adjustments'
        };
    },
    async mounted() {
        this.pagination.perPage = 20;

        if (this.allTeamMembers.length === 0) {
            this.teamMembers = await this.$store.dispatch('team/FETCH_TEAM_MEMBERS');
        } else {
            this.teamMembers = this.allTeamMembers;
        }

        if (this.customers.length === 0) {
            const list = await this.$store.dispatch('team/FETCH_TEAM_CUSTOMERS');
            this.customerList = list.items;
        } else {
            this.customerList = this.customers;
        }

        if (this.invoiceAdjustmentStatuses.length === 0) {
            this.adjustmentStatuses = await this.$store.dispatch('team/FETCH_INVOICE_ADJUSTMENT_STATUSES');
        } else {
            this.adjustmentStatuses = this.invoiceAdjustmentStatuses;
        }

        if (this.invoiceAdjustmentCategories.length === 0) {
            this.adjustmentCategories = await this.$store.dispatch('team/FETCH_INVOICE_ADJUSTMENT_CATEGORIES');
        } else {
            this.adjustmentCategories = this.invoiceAdjustmentCategories;
        }

        this.filters = this.filter;

        await this.loadAdjustments();

        this.loadingRequiredData = false;

        document.querySelector('.main-panel').addEventListener('scroll', this.handleScroll, true);
    },
    beforeDestroy() {
        document.querySelector('.main-panel').removeEventListener('scroll', this.handleScroll);
    },
    methods: {
        async loadAdjustments(pageNumber = 1, perPage = 20) {
            if (this.isLoading) {
                return;
            }

            try {
                this.isLoading = true;
                const endpoint = `/api/invoice-adjustments`;
                const customer = this.isCustomer;
                const driver = this.isDriver;

                const response = await handleRequests(endpoint, {
                    params: {
                        ...this.filters,
                        isCustomer: customer,
                        isDriver: driver,
                        pageNumber,
                        perPage
                    }
                });

                this.adjustmentList = response.data.adjustments;
                this.pagination.total = response.data.totalAdjustments;
            } catch (e) {
                showErrorMessage(this, 'Error when getting adjustments', null);
            } finally {
                this.isLoading = false;
            }
        },
        async handleFilterChanged(data) {
            this.filters = Object.assign(this.filters, data);
            await this.loadAdjustments();
        },
        async handleChangePage(currentPage = 1, perPage = 20) {
            this.pagination.currentPage = currentPage;
            this.pagination.perPage = perPage;

            await this.loadAdjustments(currentPage, perPage);

            this.$router.replace({ path: this.$route.path, query: { currentPage } });
        },
        async createAdjustment() {
            this.$modal
                .show(CreateOrUpdateInvoiceAdjustmentModal, {
                    invoiceAdjustmentCategories: this.adjustmentCategories,
                    invoiceAdjustmentStatuses: this.adjustmentStatuses,
                    teamMembers: this.teamMembers,
                    customerList: this.customerList,
                    title: 'Create ',
                    isCustomer: this.isCustomer,
                    isDriver: this.isDriver
                })
                .then(async (adjustment) => {
                    if (adjustment) {
                        this.$modal.hide();
                        adjustment.forEach((adj) => {
                            this.adjustmentList.push(adj);
                        });
                    }
                });
        },
        getCategory(invoiceAdjustmentCategoryId) {
            return this.adjustmentCategories.find(
                (category) => category.invoiceAdjustmentCategoryId === invoiceAdjustmentCategoryId
            )?.category;
        },
        onSelectAll(selectAllRows) {
            this.selectedRows = [];

            this.adjustmentList.forEach((row) => {
                const name = this.adjustmentStatuses.find(
                    (status) => status.invoiceAdjustmentStatusId === row?.invoiceAdjustmentStatusId
                )?.status;
                if (
                    row.customerInvoiceId === null &&
                    row.teamMemberInvoiceId === null &&
                    name !== INVOICE_ADJUSTMENT_STATUSES.Deleted
                ) {
                    row.isSelect = selectAllRows;

                    if (selectAllRows) {
                        this.selectedRows.push(row);
                    }
                }
            });
        },
        selectRow(row) {
            if (row.customerInvoiceId === null && row.teamMemberInvoiceId === null) {
                this.adjustmentList.find((adj) => adj.invoiceAdjustmentId === row.invoiceAdjustmentId).isSelect =
                    row.isSelect;

                if (row.isSelect) {
                    this.selectedRows.push(row);
                } else {
                    this.selectedRows = this.selectedRows.filter((x) => x !== row);
                }
            }
        },
        showApproveIcon(adj) {
            const name = this.adjustmentStatuses.find(
                (status) => status.invoiceAdjustmentStatusId === adj?.invoiceAdjustmentStatusId
            )?.status;
            if (name === INVOICE_ADJUSTMENT_STATUSES.AwaitingApproval || name === INVOICE_ADJUSTMENT_STATUSES.Denied) {
                return true;
            }

            return false;
        },
        showEditIcon(adj) {
            const name = this.adjustmentStatuses.find(
                (status) => status.invoiceAdjustmentStatusId === adj?.invoiceAdjustmentStatusId
            )?.status;
            if (name === INVOICE_ADJUSTMENT_STATUSES.AwaitingApproval) {
                return true;
            }

            return false;
        },
        showDeleteIcon(adj) {
            const name = this.adjustmentStatuses.find(
                (status) => status.invoiceAdjustmentStatusId === adj?.invoiceAdjustmentStatusId
            )?.status;
            if (
                name !== INVOICE_ADJUSTMENT_STATUSES.Invoiced &&
                name !== INVOICE_ADJUSTMENT_STATUSES.Deleted &&
                name !== INVOICE_ADJUSTMENT_STATUSES.Denied
            ) {
                return true;
            }

            return false;
        },
        showUnapproveIcon(adj) {
            const name = this.adjustmentStatuses.find(
                (status) => status.invoiceAdjustmentStatusId === adj?.invoiceAdjustmentStatusId
            )?.status;
            if (
                name === INVOICE_ADJUSTMENT_STATUSES.Approved ||
                name === INVOICE_ADJUSTMENT_STATUSES.AwaitingApproval
            ) {
                return true;
            }

            return false;
        },
        refreshSingleAdjustment(adj) {
            try {
                this.adjustmentList = this.adjustmentList.map((adjustment) => {
                    return adjustment.invoiceAdjustmentId === adj.invoiceAdjustmentId ? adj : adjustment;
                });
            } catch (e) {
                showErrorMessage(this, 'Error when approving adjustments', null);
            }
        },
        async updateStatus(adjustmentIds, statusId) {
            try {
                const endpoint = `/api/invoice-adjustments/change-approval`;

                const payload = {
                    method: 'post',
                    data: {
                        invoiceAdjustmentStatusId: statusId,
                        InvoiceAdjustmentIds: adjustmentIds
                    }
                };
                this.selectedRows = [];

                const updatedAdjustments = await handleRequests(endpoint, payload);

                const filterStatusId = this.filters.invoiceAdjustmentStatusId;

                adjustmentIds.forEach((id) => {
                    const updateAdjustment = this.adjustmentList.find(
                        (adjustment) => adjustment.invoiceAdjustmentId === id
                    );

                    const updatedAdj = updatedAdjustments.data.find(
                        (adj) => adj.invoiceAdjustmentId === id
                    );

                    updateAdjustment.approvedByUserName = this.user.fullName;
                    updateAdjustment.invoiceAdjustmentStatusId = updatedAdj.invoiceAdjustmentStatusId;
                    updateAdjustment.approving = false;
                    updateAdjustment.denying = false;

                    updateAdjustment.customerInvoiceId = updatedAdj.customerInvoiceId;
                    updateAdjustment.teamMemberInvoiceId = updatedAdj.teamMemberInvoiceId;

                    if (updateAdjustment.invoiceAdjustmentStatusId !== filterStatusId && filterStatusId !== null) {
                        this.adjustmentList = this.adjustmentList.filter(
                            (adj) => adj.invoiceAdjustmentId !== updateAdjustment.invoiceAdjustmentId
                        );
                    }
                });
            } catch (e) {
                showErrorMessage(this, 'Error updating adjustment', null);

                adjustmentIds.forEach((id) => {
                    const updateAdjustment = this.adjustmentList.find(
                        (adjustment) => adjustment.invoiceAdjustmentId === id
                    );
                    updateAdjustment.approving = false;
                });
            }
        },
        async bulkApprove() {
            try {
                this.$messageBox
                    .show({
                        class: 'sm-modal-container',
                        title: 'Approve Adjustment',
                        body: 'Are you sure you want to approve these adjustments?',
                        buttons: ['Yes', 'No']
                    })
                    .then(async (response) => {
                        if (response.toLowerCase() === 'yes') {
                            const ids = this.selectedRows.map((x) => x.invoiceAdjustmentId);
                            const statusId = this.adjustmentStatuses.find(
                                (status) => status.status === INVOICE_ADJUSTMENT_STATUSES.Approved
                            )?.invoiceAdjustmentStatusId;

                            ids.forEach((x) => {
                                this.adjustmentList.find(
                                    (adjustment) => adjustment.invoiceAdjustmentId === x
                                ).approving = true;
                            });

                            await this.updateStatus(ids, statusId);
                        }
                    });
            } catch (e) {
                showErrorMessage(this, 'Error when bulk approving adjustments', null);
            }
        },
        async approveAdjustment(adj) {
            try {
                this.adjustmentList.find(
                    (adjustment) => adjustment.invoiceAdjustmentId === adj.invoiceAdjustmentId
                ).approving = true;
                const statusId = this.adjustmentStatuses.find(
                    (status) => status.status === INVOICE_ADJUSTMENT_STATUSES.Approved
                )?.invoiceAdjustmentStatusId;

                await this.updateStatus([adj.invoiceAdjustmentId], statusId);
            } catch (e) {
                showErrorMessage(this, 'Error when approving adjustments', null);
            }
        },
        async bulkDeny() {
            try {
                this.$messageBox
                    .show({
                        class: 'sm-modal-container',
                        title: 'Deny Adjustment',
                        body: 'Are you sure you want to deny these adjustments?',
                        buttons: ['Yes', 'No']
                    })
                    .then(async (response) => {
                        if (response.toLowerCase() === 'yes') {
                            const ids = this.selectedRows.map((x) => x.invoiceAdjustmentId);
                            const statusId = this.adjustmentStatuses.find(
                                (status) => status.status === INVOICE_ADJUSTMENT_STATUSES.Denied
                            )?.invoiceAdjustmentStatusId;

                            ids.forEach((x) => {
                                this.adjustmentList.find(
                                    (adjustment) => adjustment.invoiceAdjustmentId === x
                                ).denying = true;
                            });

                            await this.updateStatus(ids, statusId);
                        }
                    });
            } catch (e) {
                showErrorMessage(this, 'Error when bulk approving adjustments', null);
            }
        },
        async denyAdjustment(adj) {
            try {
                this.adjustmentList.find(
                    (adjustment) => adjustment.invoiceAdjustmentId === adj.invoiceAdjustmentId
                ).denying = true;
                const statusId = this.adjustmentStatuses.find(
                    (status) => status.status === INVOICE_ADJUSTMENT_STATUSES.Denied
                )?.invoiceAdjustmentStatusId;

                await this.updateStatus([adj.invoiceAdjustmentId], statusId);
            } catch (e) {
                showErrorMessage(this, 'Error when approving adjustments', null);
            }
        },
        async edit(adj) {
            this.$modal
                .show(CreateOrUpdateInvoiceAdjustmentModal, {
                    invoiceAdjustmentCategories: this.adjustmentCategories,
                    invoiceAdjustmentStatuses: this.adjustmentStatuses,
                    teamMembers: this.teamMembers,
                    customerList: this.customerList,
                    adjustmentData: adj,
                    title: 'Update ',
                    startTab: 1
                })
                .then(async (adjustment) => {
                    if (adjustment) {
                        this.$modal.hide();
                        this.refreshSingleAdjustment(adjustment);
                    }
                });
        },
        async bulkDelete() {
            try {
                this.$messageBox
                    .show({
                        class: 'sm-modal-container',
                        title: 'Delete Adjustment',
                        body: 'Are you sure you want to delete these adjustments?',
                        buttons: ['Yes', 'No']
                    })
                    .then(async (response) => {
                        if (response.toLowerCase() === 'yes') {
                            const ids = this.selectedRows.map((x) => x.invoiceAdjustmentId);
                            const statusId = this.adjustmentStatuses.find(
                                (status) => status.status === INVOICE_ADJUSTMENT_STATUSES.Deleted
                            )?.invoiceAdjustmentStatusId;

                            ids.forEach((x) => {
                                this.adjustmentList.find(
                                    (adjustment) => adjustment.invoiceAdjustmentId === x
                                ).deleting = true;
                            });

                            await this.updateStatus(ids, statusId);
                            ids.forEach((x) => {
                                this.adjustmentList = this.adjustmentList.filter(
                                    (adjustment) => adjustment.invoiceAdjustmentId !== x
                                );
                            });
                        }
                    });
            } catch (e) {
                showErrorMessage(this, 'Error when approving adjustments', null);
            }
        },
        async deleteAdjustment(adj) {
            try {
                this.$messageBox
                    .show({
                        class: 'sm-modal-container',
                        title: 'Delete Adjustment',
                        body: 'Are you sure you want to delete this adjustments?',
                        buttons: ['Yes', 'No']
                    })
                    .then(async (response) => {
                        if (response.toLowerCase() === 'yes') {
                            this.adjustmentList.find(
                                (adjustment) => adjustment.invoiceAdjustmentId === adj.invoiceAdjustmentId
                            ).deleting = true;
                            const statusId = this.adjustmentStatuses.find(
                                (status) => status.status === INVOICE_ADJUSTMENT_STATUSES.Deleted
                            )?.invoiceAdjustmentStatusId;

                            await this.updateStatus([adj.invoiceAdjustmentId], statusId);
                            this.adjustmentList = this.adjustmentList.filter(
                                (adjustment) => adjustment.invoiceAdjustmentId !== adj.invoiceAdjustmentId
                            );
                        }
                    });
            } catch (e) {
                showErrorMessage(this, 'Error when approving adjustments', null);
            }
        },
        getColumnName() {
            if (this.isDriver) 
                return 'Team Member';

            if (this.isCustomer) 
                return 'Customer';

            return 'Apply to';
        },
        handleScroll() {
            const target = document.querySelector('.md-card-header');
            const scrollPos = target.getBoundingClientRect().top;

            if (scrollPos <= 80) {
                this.isFixedSelector = true;
                return;
            }

            this.isFixedSelector = false;
        }
    }
};
</script>

<style lang="scss" scoped>
.container-dashboard ::v-deep .md-card {
    margin-bottom: 0;
}

.search-container {
    padding-top: 30px;
}

.card-container {
    display: inline-flex;
}

.body-list {
    position: relative;
    padding-left: 8px !important;
    padding-top: 30px !important;
}

.sticky-selection {
    z-index: 1000 !important;
    transition: top 0.1s ease;
}

.sticky-selection.fixed {
    position: sticky !important;
    top: 70px !important;
}

.no-result-message {
    position: absolute;
    justify-self: anchor-center;
}

.card-container-right {
    display: inline-flex;
    float: right !important;
    z-index: 1;
    position: absolute;
    padding-right: 15px !important;
}

.create-container {
    padding-top: 10px;
    inline-size: -webkit-fill-available;
    z-index: 1;
    position: absolute;
    padding-right: 15px !important;
}

.custom-add {
    height: 30px;
    width: 30px;
    min-width: 30px;
}

.status {
    color: #fff !important;
    width: initial;
    height: initial;
    line-height: 1;
    text-transform: uppercase;
    padding: 5px 12px;
    border-radius: 12px;
    display: inline-block;
}

.loading-position {
    top: 55%;
}

.actions-container {
    width: 180px;

    ::v-deep .md-table-cell-container {
        margin-left: -15px !important;
    }
}

.action-icon {
    height: 28px !important;
    min-width: 28px !important;
    max-width: 28px !important;
    margin: 2px !important;
}

.sync-loader {
    display: inline-block;
    background-color: #2b93ff;
    border-radius: 50%;
    width: 29px;
    height: 29px;

    svg {
        margin-top: 3px;
        margin-left: 2px;
    }
}

.name-container {
    max-width: 180px !important;
    width: 180px !important;
}

.bulk-section {
    position: absolute;
    top: -20px;
    width: 545px;
    margin-left: auto;
    margin-right: auto;
    left: 0;
    right: 0;
    text-align: center;
    background-color: #cfeefa;
    color: #2b93ff;
    font-weight: 400;
    padding: 5px 10px 5px 20px;

    > div {
        width: 60%;
        display: inline-block;
        vertical-align: middle;
        text-align: left;
    }

    > div:last-child {
        width: 40%;
        text-align: right;

        button {
            height: 30px;
            width: 30px;
            min-width: 30px;
        }

        .dropdown {
            width: 120px;
            background-color: #ff9800 !important;
            display: inline-block;
            text-align: center;
            color: #fff;
            text-transform: uppercase;
            font-size: 12px;
            height: 30px;
            line-height: 30px;
            margin-top: 6px;
            cursor: pointer;
        }
    }
}

.checkbox-container {
    margin: 0 !important;
}

.checkbox-head {
    margin-left: 8px !important;
    margin-top: 15px !important;
}
</style>
